import React from 'react';

import { getImage } from '@utils';

export const CarImage = ({ shortcode }) => (
  <div
    style={{
      width: '360px',
      height: '182px',
      overflow: 'hidden',
      margin: 'auto',
    }}
  >
    <img
      style={{
        objectFit: 'cover',
        objectPosition: '10px -30px',
        width: '100%',
        height: '100%',
      }}
      src={getImage({ shortcode, width: 720, height: 500, scene: 'alpha' })}
      alt={shortcode}
    />
  </div>
);
